var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-bar-chart d-flex align-end",staticStyle:{"height":"48px","gap":"4px","width":"100%"}},_vm._l((_vm.normalized),function(bar,i){return _c('div',{key:i,style:({
            width: '100%',
            height: `${bar.height}%`,
            backgroundColor: bar.highlight ? 'var(--color-primary)' : `rgba(112, 42, 225, ${bar.opacity})`,
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            boxShadow: bar.highlight ? '0 0 10px rgba(112,42,229,.25)' : 'none',
            transition: 'all 300ms',
        })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }